


































































































































import { Component, Vue, Watch, Ref } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import BusinessUpdateContactList from './Update/BusinessUpdateContactList.vue';
import BusinessUpdateAddressList from './Update/BusinessUpdateAddressList.vue';
import BusinessTradeReferenceFrom from './Update/BusinessTradeReferenceFrom.vue';
import BusinessCreditCheckReview from './Update/BusinessCreditCheckReview.vue';

@Component({
  components: {
    BusinessUpdateContactList,
    BusinessUpdateAddressList,
    BusinessTradeReferenceFrom,
    BusinessCreditCheckReview,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
    ...mapState('Business', {
      business: 'business',
    }),
    ...mapState('Country', {
      countries: 'countries',
    }),
  },
})
export default class BusinessCreditCheck extends Vue {
  @Ref() readonly form!: { validate: (any?: any) => Promise<boolean> };

  isMounted = false;

  activeBusiness!: Model;
  business!: Model;

  tmpBusiness = {
    object_id: '',
    name: '',
    abn: '',
    business_contacts: [],
    business_addresses: [],
    billing_contact: null,
    director_contact: null,
    billing_address: null,
    referee_1: {
      business_name: '',
      abn: '',
      contact_full_name: '',
      contact_email: '',
      contact_phone: '',
    },
    referee_2: {
      business_name: '',
      abn: '',
      contact_full_name: '',
      contact_email: '',
      contact_phone: '',
    },
  };

  countries!: [
    {
      id: number;
      name: string;
      states: {
        id: number;
        name: string;
      }[];
    }
  ];

  currentStep = 0;
  isLoading = false;
  canProceedBusinessDetails = false;
  canProceedBillingContact = false;
  canProceedDirectorContact = false;
  canProceedBillingAddress = false;
  canProceedReferee1 = false;
  canProceedReferee2 = false;

  statement = '';

  isApiFetch = {
    isApiFetchBusinessFinished: false,
    isApiFetchCountryFinished: false,
    isApiFetchDocumentFinished: false,
  };

  get steps() {
    return [
      {
        title: 'Step 1',
        subtitle: 'Terms & Conditions',
        canProceed: () => {
          return this.isMounted;
        },
      },
      {
        title: 'Step 2',
        subtitle: 'Business Details',
        canProceed: () => {
          return (
            this.canProceedBusinessDetails &&
            this.canProceedBillingContact &&
            this.canProceedDirectorContact &&
            this.canProceedBillingAddress &&
            this.canProceedReferee1 &&
            this.canProceedReferee2
          );
        },
      },
      {
        title: 'Step 3',
        subtitle: 'Review & Submit',
        canProceed: () => true,
      },
    ];
  }

  @Watch('business', { deep: true })
  watchBusiness(v) {
    const referee_1 = this.tmpBusiness.referee_1;
    const referee_2 = this.tmpBusiness.referee_2;
    this.tmpBusiness = _.cloneDeep(v);
    this.tmpBusiness = Object.assign({}, this.tmpBusiness, {
      referee_1: referee_1,
      referee_2: referee_2,
    });
  }

  @Watch('tmpBusiness', { deep: true })
  watchTmpBusiness() {
    this.validate();
  }

  get contactText() {
    if (
      !this.isEmpty(this.tmpBusiness.billing_contact) &&
      !this.isEmpty(this.tmpBusiness.director_contact)
    ) {
      return 'Comfirm your billing contact & director contact';
    } else if (!this.isEmpty(this.tmpBusiness.business_contacts)) {
      return "Click the 'Set as Billing Contact' and 'Set as Director Contact' to select a billing contact and a director contact from current contacts, or add a new one";
    } else {
      return 'Please insert your billing contact details and director contact details (minimum of one contact is required)';
    }
  }

  get addressText() {
    if (!this.isEmpty(this.tmpBusiness.billing_address)) {
      return 'Comfirm your billing address';
    } else if (!this.isEmpty(this.tmpBusiness.business_addresses)) {
      return "Click the 'Set as Billing Address' to select a billing address frow current addresses, or add a new one";
    } else {
      return 'Please insert your billing address details (minimum of one address is required)';
    }
  }

  beforeMount() {
    this.$store
      .dispatch('Business/fetch', {
        businessOid: this.activeBusiness.object_id,
        config: {
          params: {
            expand: [
              'business_contacts',
              'business_addresses',
              'billing_address',
              'billing_contact',
              'postal_address',
              'primary_contact',
              'director_contact',
            ],
          },
        },
      })
      .then(() => {
        this.isApiFetch['isApiFetchBusinessFinished'] = true;
      });

    if (!this.countries.length) {
      this.$store
        .dispatch('Country/fetchList', {
          params: {
            expand: ['states'],
          },
        })
        .then(() => {
          this.isApiFetch['isApiFetchCountryFinished'] = true;
        });
    } else {
      this.isApiFetch['isApiFetchCountryFinished'] = true;
    }

    this.$store
      .dispatch('Document/fetch', 'terms-and-conditions')
      .then((response) => {
        this.isApiFetch['isApiFetchDocumentFinished'] = true;
        this.statement = response.data.data;
      });
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }
      if (isFinished) {
        if (this.business.active_business_credit_check) {
          const referee_1 = this.business.active_business_credit_check
            .referee_1;
          const referee_2 = this.business.active_business_credit_check
            .referee_2;
          this.tmpBusiness = Object.assign({}, this.tmpBusiness, {
            referee_1: referee_1,
            referee_2: referee_2,
          });
        }
        this.isMounted = true;
      }
    }
  }

  validate() {
    if (!this.isEmpty(this.tmpBusiness.billing_contact)) {
      this.canProceedBillingContact = true;
    } else {
      this.canProceedBillingContact = false;
    }
    if (!this.isEmpty(this.tmpBusiness.director_contact)) {
      this.canProceedDirectorContact = true;
    } else {
      this.canProceedDirectorContact = false;
    }
    if (!this.isEmpty(this.tmpBusiness.billing_address)) {
      this.canProceedBillingAddress = true;
    } else {
      this.canProceedBillingAddress = false;
    }
    if (
      !this.isEmpty(this.tmpBusiness.abn) &&
      !this.isEmpty(this.tmpBusiness.name)
    ) {
      this.canProceedBusinessDetails = true;
    } else {
      this.canProceedBusinessDetails = false;
    }
  }

  handleSubmit() {
    this.isLoading = true;
    this.$store.dispatch('Business/update', this.tmpBusiness).then(() => {
      this.$store
        .dispatch('Business/creditCheck', this.tmpBusiness)
        .then(async () => {
          this.isLoading = false;

          // Due to business credit check information stored with user details,
          // once the a new credit check application submitted, the associated business information stored in Vuex
          // should be updated.
          // For a quick fix, we await the action of fetching user details. So that Vuex can have the latest business
          // credit check information.
          // Further optimization is required.
          await this.$store.dispatch('Auth/fetchUser');

          this.$store.commit('SET_SNACKBAR', {
            show: true,
            type: 'success',
            message: 'Application submitted!',
          });
          this.$router.push({
            name: 'business-update',
            params: {
              businessOid: this.tmpBusiness.object_id,
            },
          });
        });
    });
  }

  isEmpty(v) {
    return _.isEmpty(v);
  }

  toAddress(v) {
    let address = v.address1;
    if (v.address2) {
      address += ', ' + v.address2;
    }
    if (v.city) {
      address += ', ' + v.city;
    }
    if (v.postcode) {
      address += ', ' + v.postcode;
    }
    if (v.state_id && v.country_id) {
      const country = this.countries.find(
        (country) => country.id == v.country_id
      );
      const state = country?.states.find((state) => state.id == v.state_id);
      if (country && state) {
        address += ', ' + state.name + ', ' + country.name;
      }
    }
    return address;
  }

  stepChange(index) {
    if (index == 2) {
      // update business info
      this.isLoading = true;
      this.$store.dispatch('Business/update', this.tmpBusiness).then(() => {
        this.isLoading = false;
        this.$store.dispatch('Business/fetch', {
          businessOid: this.business.object_id,
          config: {
            params: {
              expand: [
                'business_contacts',
                'business_addresses',
                'billing_address',
                'billing_contact',
                'postal_address',
                'primary_contact',
                'director_contact',
              ],
            },
          },
        }); // end of dispatch business/fetch
      }); // end of .then
    }
  }

  navigate(from, to, done) {
    this.currentStep = to;
    done();
  }
}
